<template>
    <div>
        <b-modal ref="dish-group-selector-modal"
                 hide-footer
                 scrollable
                 size="lg"
                 title="Dish groups">
            <div class="dish-group-selector px-3">

                <div class="row mb-2">
                    <div class="col-9 px-0">
                        <b-btn v-if="onlyParent"
                               class="mr-3"
                               variant="success"
                               @click="applayGroup(true)">
                            <div><i class="mdi mdi-home mdi-18px"></i> {{ $t("#TR-main") }}</div>
                        </b-btn>

                        <h6 v-if="onlyParent" class="text-success d-inline">&nbsp;
                            <span v-if="selectedGroup">{{ $t("#TR-selected-group") }}: <span class="font-weight-bold">{{ selectedGroup.name }}</span></span>
                            <span v-if="!selectedGroup">{{ $t("#TR-selected-group") }}: <span class="font-weight-bold">{{ $t("#TR-main") }}</span></span>
                        </h6>
                        <h6 v-else class="text-success d-inline">&nbsp;
                            <span v-if="selectedGroup">{{ $t("#TR-current-group") }}: <span class="font-weight-bold">{{ selectedGroup.name }}</span></span>
                            <span v-if="!selectedGroup">{{ $t("#TR-current-group") }}: <span class="font-weight-bold">{{ $t("#TR-main") }}</span></span>
                        </h6>

                    </div>

                    <div class="col-3 text-right px-0">
                        <b-button type="button"
                                  :variant="selectedGroup ? 'danger' : 'light'"
                                  :disabled="!selectedGroup"
                                  class="mx-1 text-nowrap"
                                  @click="dishGroupBack()">
                            <span class="mdi mdi-arrow-left-bold"></span> {{ $t("#TR-back") }}
                        </b-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <b-list-group class="row flex-row mb-3">
                            <b-list-group-item v-for="group in dishGroupList"
                                               :key="group.guid"
                                               button
                                               :disabled="onlyParent && currentDishGroup.sifr === group.sifr"
                                               class="col-xs-12 col-sm-6 col-md-6 col-lg-4 border border-bottom-1 p-2 d-flex justify-content-between align-items-center"
                                               @click="selectGroup(group)">
                                <div>{{ group.name }}</div>
                                <div v-if="group['hasChilds']"
                                     class="mdi mdi-menu-right mdi-24px text-success">
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <b-button type="button"
                                  :variant="selectedGroup ? 'success' : 'light'"
                                  :disabled="!selectedGroup"
                                  class="mx-1 text-nowrap"
                                  @click="applayGroup()">
                            <span class="mdi mdi-group"></span> {{ $t("#TR-select-group") }}
                        </b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

import { ApiDishGroup } from '@/services/api';
import MSG from '@/services/notify';

export default {
    name: 'DishGroupSelectorModal',

    props: {
        onlyParent: {
            type: Boolean,
            default: () => {
                return false;
            }
        },

        currentDishGroup: {
            type: Object,
            default: () => {
                return null;
            }
        }
    },

    data() {
        return {
            dishGroupList: [],
            selectedGroup: null,
            selectedGroupHistory: []
        };
    },

    methods: {

        async getDishGroup(sifr = null) {
            const result = await ApiDishGroup.list(sifr);

            this.dishGroupList = [];

            if (result.error) {
                MSG.error(result.error, this);
                this.cancel();
            } else {
                this.dishGroupList = result.data;
            }
        },

        selectGroup(group) {

            if (!group) {

                return;
            }

            if (group['hasChilds']) {
                this.getDishGroup(group.sifr);
                this.selectedGroup = group;
                this.selectedGroupHistory.push(this.selectedGroup);
            } else {
                this.selectedGroup = group;
                this.applayGroup();
            }
        },

        applayGroup(main = false) {
            /* if (main) {
                this.$emit('selectDishGroup', null);
                return;
            } */
            this.$emit('selectDishGroup', this.selectedGroup);
            this.selectedGroup = null;
            this.selectedGroupHistory = [];
            this.cancel();
        },

        async openDishGroupSelectorView() {
            this.$refs['dish-group-selector-modal'].show();
            /*  if (this.currentDishGroup) {
                this.getDishGroup(this.currentDishGroup.parent);
            } else {
                this.getDishGroup();
            } */
            this.getDishGroup();
        },

        cancel() {
            this.$refs['dish-group-selector-modal'].hide();
        },

        dishGroupBack() {
            if (!this.selectedGroup) {
                return;
            }
            this.getDishGroup(this.selectedGroup.parent);
            const findGroupIdx = this.selectedGroupHistory.findIndex(r => r['sifr'] === this.selectedGroup.parent);
            if (findGroupIdx !== -1) {
                this.selectedGroup = this.selectedGroupHistory[findGroupIdx];
            } else {
                this.selectedGroup = null;
                this.selectedGroupHistory = [];
            }
        }

    }
};
</script>

<style lang="stylus">

.list-group-item-action {
    margin: 0 0 3px 0;
}

.list-group-item-action:hover {
    background-color: #f0fcf0;
}


.list-group-item.disabled,
.list-group-item:disabled {
    color: #ffffff;
    pointer-events: none;
    background-color: #cacaca;
}

</style>
